import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

export interface UseAdResponse extends BackendResponse {
  success: boolean;
  campaign_id: number;
  adItem_id: number;
  width: number;
  height: number;
  target: string;
  link: string;
  source: string;
}

interface Params {
  zone: number;
  type: string;
  display: string;
  refresh?: number;
}

export function useAdPicture(params: Params) {
  return useQuery({
    queryKey: ['zone', +params.zone],
    queryFn: () => fetchAdPicture(params),
    staleTime: 0,
    refetchInterval: params.refresh ? params.refresh*1000 : 0
  });
}

function fetchAdPicture(params: Params) {
  return apiClient
    .get<UseAdResponse>(`https://kads.corsica/ad?zone=${params.zone}&type=json&format=${params.type}`)
    .then(response => {
      return response.data;
    });
}
